export const LIST_COUNTRY_META: string = 'LIST_COUNTRY_META';
export const LIST_COUNTRY_META_SUCCESS: string = 'LIST_COUNTRY_META_SUCCESS';
export const LIST_COURSE_META: string = 'LIST_COURSE_META';
export const LIST_COURSE_META_SUCCESS: string = 'LIST_COURSE_META_SUCCESS';
export const SET_SELECTED_COURSE: string = "SET_SELECTED_COURSE";
export const SET_USER_COURSE = "SET_USER_COURSE";
export const SET_USER_COURSE_SUCCESS = "SET_USER_COURSE_SUCCESS";
export const UPDATE_SELECTED_COURSE = "UPDATE_SELECTED_COURSE";
export const SEARCH = "SEARCH";
export const SUBSCRIPTION = "LIST_SUBSCRIPTION";